export const emoteDurationInSeconds = 15;
export const numberOfSameEmotePerMinuteAllowed = 5;
export const numberOfUsersOnLeaderboard = 5;
export const secondsBetweenLeaderboardDisplay = 60;
export const secondsLeaderboardDisplaysFor = 10;